// extracted by mini-css-extract-plugin
module.exports = {"PartnerBox":"Partners_PartnerBox__1KFcc","PartnerLogoBox":"Partners_PartnerLogoBox__3IFTc","Link":"Partners_Link__KSDm3","PartnerLogo":"Partners_PartnerLogo__2LyIq"};